import http from '@/request'

const base_url = '/api'

// 列表
export function getCode(timestamp) {
    return http.get({
        url: `/code/get?randomStr=${timestamp}`,
    })
}


export function login(res) {
    let params = Object.assign({grant_type: 'password', scope: 'server'}, res)
    return http.post({
        url: base_url + '/user/login/passportLogin',
        data: params
    })
}

export function getAllPlatform(res) {
    return http.get({
        url: `${base_url}/user/user/getallplatform`,
        data: res
    })
}

export function getUserInfo(res) {
    return http.get({
        url: `${base_url}/user/user/info`,
        data: res
    })
}

/**
 * 获取营销类目
 * @returns {*}
 */
export function loadFirstCategory() {
    return http.post({
        url: `${base_url}/product/productCategoryBack/firstCategory`
    })
}

/**
 * 注册供货商
 * @returns {*}
 */
export function sellerRegister(postData) {

    return http.post({
        url: `${base_url}/user/seller/register`,
        data: postData
    })
}



export function uploadOtherUrl() {
    return base_url + '/base/file/upload/other'
}



export function logout() {
    return http.post({
        url: base_url + '/auth/token/logout'
    })
}

export function getProvince(res) {
    return http.post({
        url: `${base_url}/base/district/province`,
        method: 'post',
        data: res
    })
}

export function getCity(res) {
    return http.post({
        url: `${base_url}/base/district/city/${res}`,
    })
}

export function getArea(res) {
    return http.post({
        url: `${base_url}/base/district/area/${res}`,
    })
}